import { createContext, useContext } from 'react';
import {
  GetJourneyVisitorEligibility,
  useGetJourneyVisitorEligibility,
} from './useGetJourneyVisitorEligibility';
import { getWorkflow, getWorkflowType } from 'modules/workflows/ducks';
import { useSelector } from 'react-redux';

type JourneyVisitorTrackingContextState = GetJourneyVisitorEligibility & {
  isJVTEnabled: boolean;
};

const JourneyVisitorTrackingContext = createContext<JourneyVisitorTrackingContextState>({
  isLoading: false,
  error: null,
  checkCurrentJourneyEligibility: () => {},
  checkPublishedJourneyEligibility: () => {},
  currentJourneyEligibility: {
    isJourneyEligible: false,
    jvtEligibilityMessage: [],
  },
  publishedJourneyEligibility: {
    isJourneyEligible: false,
    jvtEligibilityMessage: [],
  },
  isJVTEnabled: false,
});

type JourneyVisitorTrackingContextProps = {
  children: React.ReactNode | React.ReactNode[];
};

export const JourneyVisitorTrackingContextProvider = ({
  children,
}: JourneyVisitorTrackingContextProps) => {
  const handlers = useGetJourneyVisitorEligibility();

  const workflow = useSelector(getWorkflow);
  const { isDraft } = useSelector(getWorkflowType);
  const isJVTEnabled = workflow?.visitorTrackingEnabled || false;
  const isJVTEnabledOnPublishedJourney =
    workflow?.workflowReference?.visitorTrackingEnabled || false;

  const context: JourneyVisitorTrackingContextState = {
    ...handlers,
    isJVTEnabled: isDraft ? isJVTEnabledOnPublishedJourney : isJVTEnabled,
  };

  return (
    <JourneyVisitorTrackingContext.Provider value={context}>
      {children}
    </JourneyVisitorTrackingContext.Provider>
  );
};

export const useJourneyVisitorTrackingContext = () => useContext(JourneyVisitorTrackingContext);
